const emojis = ["👍", "❤️", "😂", "😮", "😢", "😡"];

export default function ReactionPicker({ onSelect }) {
  return (
    <div
      className="d-flex align-items-center bg-white shadow rounded-pill px-2 py-1"
      style={{
        gap: "6px",
        border: "1px solid #e9ecef",
      }}
    >
      {emojis.map((emoji) => (
        <button
          key={emoji}
          type="button"
          className="btn btn-light border-0 d-flex align-items-center justify-content-center"
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            fontSize: "18px",
            transition: "transform 0.15s ease, background 0.15s ease",
          }}
          onClick={() => onSelect(emoji)}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.25)";
            e.currentTarget.style.background = "#f1f3f5";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.background = "transparent";
          }}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}